// Adresse du compte en attente d'activation, mémorisée le temps de la vérification.
//
// sessionStorage (et non le state React) : sans ça, un simple rafraîchissement de
// l'écran de fin d'inscription perdait l'adresse et rendait la page inutilisable.
const KEY = 'pending_verification_email';

export function storePendingVerificationEmail(mail) {
  try {
    sessionStorage.setItem(KEY, mail);
  } catch (_) {
    // Navigation privée / stockage indisponible : l'adresse reste saisissable à la main.
  }
}

export function readPendingVerificationEmail() {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch (_) {
    return '';
  }
}

export function clearPendingVerificationEmail() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_) {
    // rien à faire
  }
}
